export default function Arrow({ isRotated, color, strokeWidth }) {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: isRotated ? 'scaleY(-1)' : 'scaleY(1)',
        transition: 'transform 0.3s ease',
      }}
    >
      <path
        d="M2 2L7.29289 7.68539C7.68342 8.10487 8.31658 8.10487 8.70711 7.68539L14 2"
        stroke={color || '#F6F6F6'}
        strokeWidth={strokeWidth || '3'}
        strokeLinecap="round"
      />
    </svg>
  );
}
